import React from 'react';
import Modal2, { Modal2Footer, Modal2Button } from '../../common/Modal2';
import { Info } from 'lucide-react';

export interface ApproveModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: React.ReactNode;
  processing?: boolean;
  confirmText?: string;
  cancelText?: string;
}

const ApproveModal: React.FC<ApproveModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  processing = false,
  confirmText = "Approve",
  cancelText = "Cancel",
}) => {
  return (
    <Modal2
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      closable
      maskClosable={false}
      footer={
        <Modal2Footer>
          <Modal2Button variant="secondary" onClick={onClose} disabled={processing}>
            {cancelText}
          </Modal2Button>
          <Modal2Button
            variant="primary"
            onClick={onConfirm}
            loading={processing}
            disabled={processing}
          >
            {processing ? "Processing..." : confirmText}
          </Modal2Button>
        </Modal2Footer>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-start gap-3 text-text-secondary">
          <Info className="w-5 h-5 text-primary-500 mt-0.5 flex-none" />
          <p className="text-sm font-medium leading-relaxed">{message}</p>
        </div>
      </div>
    </Modal2>
  );
};

export default ApproveModal;
